import { ColorEnum } from '@/constants/color'
import CancelButton from '@/features/common/buttons/CancelButton'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import { useFormQuantity } from '@/features/pos/components/ProductConfigurationModal/form'
import { useConfirmForm } from '@/features/pos/components/ProductConfigurationModal/parts/ActionButtons/hooks'
import QuantitySelector from '@/features/pos/components/ProductConfigurationModal/parts/QuantitySelector'
import { Actions } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

type ActionButtonsProps = {
    confirmDisabled: boolean
    allowQuantityChange?: boolean
} & Actions

const ActionButtons: FC<ActionButtonsProps> = ({
    confirmDisabled,
    allowQuantityChange,
    onConfirm,
    onCancel,
    cancelLabel,
}) => {
    const [{ isValid, isSubmitting }, confirm] = useConfirmForm(onConfirm)
    const quantity = useFormQuantity()

    return (
        <View style={styles.container}>
            {allowQuantityChange && <QuantitySelector {...quantity} />}
            <View style={styles.actions}>
                <View style={styles.column}>
                    <CancelButton disabled={isSubmitting} onPress={onCancel} label={cancelLabel} />
                </View>
                <View style={styles.column}>
                    <ConfirmButton
                        disabled={confirmDisabled || !isValid}
                        loading={isSubmitting}
                        onConfirm={confirm}
                    />
                </View>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignContent: 'stretch',
        backgroundColor: ColorEnum.VIOLET_100,
        borderRadius: 16,
        padding: 16,
        gap: 16,
    },
    actions: {
        flexDirection: 'row',
        gap: 16,
    },
    column: {
        flex: 1,
        minWidth: 0,
    },
})

export default ActionButtons
